import { forwardRef, ReactNode, useState } from 'react'
import { ImageOff } from 'lucide-react'
import { MessageProps } from './types'
import { MessageTypeEnum } from 'constants/call'

// картинка-вложение реплики (слайд презентации): не должна распирать пузырь.
// Если ссылка не открылась, на месте картинки остаётся заглушка: молча убрать
// слайд нельзя — кандидат должен видеть, что материал был, а не отвечать на
// вопросы по нему вслепую
function MessageImage({ url }: { url: string }): ReactNode {
  const [isFailed, setIsFailed] = useState(false)

  if (isFailed) {
    return (
      <div className="flex h-[120px] w-[min(320px,70vw)] items-center justify-center rounded-[8px] border border-dashed border-gray-300 bg-gray-50">
        <ImageOff className="size-6 text-gray-400" />
      </div>
    )
  }

  return (
    <img
      src={url}
      alt="Slide"
      className="h-auto w-auto max-h-[50vh] max-w-[min(320px,70vw)] rounded-[8px] object-contain"
      onError={() => setIsFailed(true)}
    />
  )
}

// eslint-disable-next-line react/display-name
export const MessageComponent = forwardRef<HTMLDivElement, MessageProps>(
  (
    {
      type,
      text,
      isGrouped,
      isLastInGroup,
      senderAvatar,
      senderName,
      displayTextAsRawHTML,
      imageUrls
    },
    ref
  ) => {
    if (
      type === MessageTypeEnum.outgoing &&
      (!text ||
        text === '<user_joined_chat, do_start_interview>' ||
        text.startsWith('/start-interview'))
    )
      return null

    return (
      <div
        className={`z-50 flex flex-col space-y-2 ${
          isGrouped ? 'mt-[10px]' : 'mt-[40px]'
        }`}
        ref={ref}
      >
        <div
          className={`flex items-center space-x-2 ${
            type === MessageTypeEnum.incoming ? 'justify-start' : 'justify-end'
          }`}
        >
          <div
            className={`rounded-lg p-2 px-[16px] py-[12px] text-left ${
              type === MessageTypeEnum.incoming
                ? 'bg-white'
                : 'bg-[var(--primary-foreground)] text-white'
            }`}
          >
            {displayTextAsRawHTML ? (
              <div dangerouslySetInnerHTML={{ __html: text || '' }} />
            ) : (
              <span className="whitespace-pre-wrap">{text}</span>
            )}

            {!!imageUrls?.length && (
              <div
                className={`flex flex-col items-start gap-[8px] ${
                  text ? 'mt-[12px]' : ''
                }`}
              >
                {imageUrls.map((url) => (
                  <MessageImage key={url} url={url} />
                ))}
              </div>
            )}
          </div>
        </div>
        {isLastInGroup && type === MessageTypeEnum.incoming && senderAvatar && (
          <div className="flex items-center space-x-2 mt-[12px]">
            <img
              src={senderAvatar}
              className="size-[24px] rounded-full object-cover"
            />
            <span className="text-gray-500 text-sm">
              {senderName?.trim() ? `${senderName.trim()} AI` : 'Aivy AI'}
            </span>
          </div>
        )}
      </div>
    )
  }
)
